interface ElementState {
    value: string;
    selection: Readonly<[number, number]>;
}

export const transformPhonePreprocessor = ({ elementState, data }: { elementState: ElementState; data: string }) => {
    let { value, selection } = elementState;

    /** При автозаполнении браузер устанавливает value напрямую, data приходит пустой.
     * Если value — полный номер, начинающийся с 8, удаляем 8.
     * */
    if (!data && value.length > 1 && /^8[\d\s(]/.test(value)) {
        value = value.replace(/^8\s*/, '');
        /** Корректируем позицию курсора после удаления символа */
        selection = [selection[0] - 1, selection[1] - 1];
    }

    /** Удаляем кавычки из вставляемых данных */
    data = data.replace(/^['"]|['"]$/g, '');

    /** Править значение вводимых символов необходимо только если:
     * 1. Вводим символы в начало строчки
     * 2. Текущее значение === +
     * */
    if (selection[0] === 0 || (selection[0] === 1 && value === '+')) {
        /** Если вводим один символ 7 или 8 заменяем этот символ на 7 и очищаем текущее значение */
        if (data === '8' || data === '7') {
            value = '';
            data = '7';
        } else {
            /** Удаляем +7 или 8 из начала строки (маска сама добавит +7) */
            data = data.replace(/^(\+7|8)\s*/, '');
        }
    }

    return {
        elementState: {
            selection,
            value,
        },
        data,
    };
};
